<div class="wrapper">
  <div class="header__wrapper">
    <h2>{{ '+SERVICE_TOOL.CALL_PAGE_HEADER_TITLE' | translate }}</h2>
    <div class="header__description"></div>
  </div>

  <ng-container *ngrxLet="serviceTicketStore.callPageAvailableSteps$ as availableSteps">
    <div class="column">
      <div
        *ngIf="availableSteps.includes(CallPageSteps.Feedback)"
        data-at-step-ticket-description
        class="step__wrapper"
      >
        <h3 class="step__counter">{{ '+SERVICE_TOOL.STEP_GENERIC' | translate }} 1</h3>
        <div class="step__content">
          <app-service-ticket-feedback></app-service-ticket-feedback>
        </div>
      </div>

      <div
        *ngIf="availableSteps.includes(CallPageSteps.CallType)"
        data-at-step-call-options
        class="step__wrapper"
      >
        <h3 class="step__counter">{{ '+SERVICE_TOOL.STEP_GENERIC' | translate }} 2</h3>
        <div class="step__content">
          <app-service-ticket-call-type></app-service-ticket-call-type>
        </div>
      </div>

      <div
        *ngIf="availableSteps.includes(CallPageSteps.ResultCallNow)"
        data-at-step-call-now-result
        class="step__wrapper"
      >
        <h3 class="step__counter">{{ '+SERVICE_TOOL.STEP_GENERIC' | translate }} 3</h3>
        <div class="step__content">
          <app-service-ticket-call-result></app-service-ticket-call-result>
        </div>
      </div>

      <div
        *ngIf="availableSteps.includes(CallPageSteps.ResultArrangedCallback)"
        data-at-step-arranged-call-result
        class="step__wrapper"
      >
        <h3 class="step__counter">{{ '+SERVICE_TOOL.STEP_GENERIC' | translate }} 3</h3>
        <div class="step__content">
          <app-service-ticket-arranged-call-result></app-service-ticket-arranged-call-result>
        </div>
      </div>
    </div>

    <div class="column">
      <div
        [class.loader--visible]="
          availableSteps.includes(CallPageSteps.RoutingProviderLoader) ||
          availableSteps.includes(CallPageSteps.RequestLoader)
        "
        data-at-loader
        class="step__wrapper loader"
      >
        <h3 class="step__fullwidth">
          <vi-loader [isLoading]="true" [message]="'+GENERAL.LOADING_DATA' | translate"></vi-loader>
        </h3>
      </div>
    </div>
  </ng-container>
</div>
